import { EditProfile } from "../features";

function EditProfilePage() {
  return (
    <>
      <EditProfile.Container />
    </>
  );
}

export default EditProfilePage;
